export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <>
      <footer id="footer" className="container mt-auto py-sm-3">
        <p>© {year} CAOIT Inc. All rights reserved</p>
      </footer>
    </>
  );
}
